const SELECTORS = {
    page: '.js-customizePage',
    personalizationCanvas: '#personalization-canvas',
    mainChoice: '.js-sectionMainChoice',
    imgFront: '#img-object-front',
    imgBack: '#img-object-back',
    pixelText: '#pixel-text',
    canvasNode: '.js-customize-canvas',
    textInput: '.js-input-type1',
    fontsButtons: '.js-choice-editor .cc-choice-item',
    colorsButtons: '.js-choice-editor .cc-choice-pattern_item',
    showOtherSide: '.js-show-other-side',
    hotspotOne: '.js-customizePage .js-positionChoice-1',
    hotspotTwo: '.js-customizePage .js-positionChoice-2',
    stepOne: '.js-customize-step1',
    stepTwo: '.js-customize-step2',
    termsBottomDesktop: 'js-termsCondition--bottom-desktop',
    footer: '.js-customize-footer',
    zoomButton: '.js-zoom-button',
    termsAndConditionsModal: '.js-linkModalCustomizeTerms',
    analyticsCustomizeAction: '.js-analyticsCustomizeAction',
    pageClose: '.js-customizePage-icon_pageClose',
    personalizeAddToCart: '.js-personalizeButtonModal',
};

export default SELECTORS;
